module.exports = __webpack_public_path__ + "img/icon_twitter.ca699e57.svg";